module.exports = __webpack_public_path__ + "assets/e5b6da4ffeff150b40a2ba8f46233cf9.svg";